import { ProvideRequestedDocumentsModalPortal } from './ProvideRequestedDocumentsModalPortal';
import { ProvideRequestedDocumentsModalTrigger } from './ProvideRequestedDocumentsModalTrigger';

export const ProvideRequestedDocumentsModal = Object.freeze({
  Portal: ProvideRequestedDocumentsModalPortal,
  Trigger: ProvideRequestedDocumentsModalTrigger,
});
